import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initColorScheme } from './lib/colorScheme';
import { migrateStoredSettings } from './lib/storage';
import { installDraftGuards } from './lib/useDraft';
// Schriften (vom eigenen Server ausgeliefert): Inter für die Bedienung, Fraunces für Titel, Literata für die Manuskriptseite
import '@fontsource-variable/inter';
import '@fontsource-variable/inter/wght-italic.css';
import '@fontsource-variable/fraunces/opsz.css';
import '@fontsource-variable/literata/opsz.css';
import '@fontsource-variable/literata/opsz-italic.css';
import './styles/tokens.css';
import './styles/app.css';

// Einstellungen aus der Zeit vor der Umbenennung in Dispositio übernehmen (einmalig)
migrateStoredSettings();
// hell oder dunkel (eigene Wahl bzw. System) vor dem ersten Bild
initColorScheme();
// Ungespeicherte Texte: beim Verbergen der Seite senden, beim Schließen warnen, wieder online erneut senden
installDraftGuards();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
